import React, { useState } from "react";
import Swal from "sweetalert2";
import { asignarPaarticipantes } from "../../utils/Datos";

export const AsignarParticipantes = ({ idProcess }) => {
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [participante, setParticipante] = useState(null);

  const handleClick = () => {
    if (cargandoDatos == false) {
      setCargandoDatos(true);
      asignarPaarticipantes(idProcess).then((datos) => {
        Swal.fire({
          title: "Listo",
          text: "Se asignaron los participantes al proceso.",
          icon: "success",
          confirmButtonText: "Ok",
        });
        setCargandoDatos(false);
      });
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn  btn-secondary"
        onClick={handleClick}
        disabled={cargandoDatos}
      >
        {cargandoDatos ? (
          "Asignando Funcionarios al proceso..."
        ) : (
          <span>
            <i className="fas fa-check"></i>Asignar Funcionarios al proceso
          </span>
        )}
      </button>
    </>
  );
};
